(function(){
  const showVariantMessage = (id) => {
    const variantMessage = document.querySelector(`.product__variant-message--${id}`);
    const variantMessages = document.querySelectorAll(`.product__variant-message`);
    if (typeof variantMessage !== 'undefined' && variantMessage !== null) {
      variantMessages.forEach(variantMessage => {
        variantMessage.style.display = 'none';
      });
      variantMessage.style.display = 'block';
    } else {
      variantMessages.forEach(variantMessage => {
        variantMessage.style.display = 'none';
      });
    }
  }

  const showKlaviyoBackInStock = (available) => {
    const backInStockButton = document.querySelector('.klaviyo-bis-trigger');
    console.log('show back in stock');
    console.log('available', available)
    if (available === false){
      backInStockButton.style.display = 'block';
    } else {
      backInStockButton.style.display = 'none';
    }
  }

  document.addEventListener('variant:change', function(evt) {
    console.log(evt)
    console.log('variant change')
    if(evt.detail.variant != null){
      showVariantMessage(evt.detail.variant.id);
      showKlaviyoBackInStock(evt.detail.variant.available);
      //showComingSoonButton(evt.detail.variant)
    }
  });

})()
